import { useMutation } from '@apollo/client';
import { AclAction, FileSystemProjectNodesRelationType } from 'shared/domains/apollo/generated/types';
import { AddDocumentToProjectDocument, RemoveDocumentFromProjectDocument } from './mutation.gql';
import { ManageProjectsMenuQueryDocument } from '../useDocumentProjects/query.gql';
export const useEditProjectDocuments = () => {
    const [addMutate, addState] = useMutation(AddDocumentToProjectDocument);
    const [removeMutate, removeState] = useMutation(RemoveDocumentFromProjectDocument);
    const loading = addState.loading || removeState.loading;
    const addDocumentToProject = (projectId, documentId) => addMutate({
        variables: {
            projectId,
            node: {
                documentId,
                relationType: FileSystemProjectNodesRelationType.Regular,
                aclActions: [AclAction.Read],
            },
        },
        refetchQueries: [
            {
                query: ManageProjectsMenuQueryDocument,
                variables: { documentId },
            },
        ],
        onQueryUpdated: (observableQuery) => observableQuery.refetch(),
    });
    const removeDocumentFromProject = (projectId, documentId, nodeId) => removeMutate({
        variables: {
            projectId,
            nodeId,
        },
        refetchQueries: [
            {
                query: ManageProjectsMenuQueryDocument,
                variables: { documentId },
            },
        ],
        onQueryUpdated: (observableQuery) => observableQuery.refetch(),
    });
    return { addDocumentToProject, removeDocumentFromProject, loading };
};
